import React from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.css";
import Footer from "src/components/footer";
import { Link } from "react-router-dom";
import "react-lazy-load-image-component/src/effects/blur.css";
import BreadcrumbPrivacy from "./component/BreadcrumbPrivacy";
import { pageRoutes } from "src/shared/utils/pageRoutes.constant";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="page-container-privacy-policy">
<       div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>Privacy Policy</h1>
            <p className='heading-desc display-none drop-in-2 drop-in-3'>We are committed to safeguarding your privacy with advanced security protocols, responsible data practices, and a promise of complete confidentiality.</p>
          </div>
          <div className='last-updated'>Last updated: 29 July, 2025</div>
            <Link to={pageRoutes.PrivacyPolicy} className='no-decoration '><BreadcrumbPrivacy text={'Privacy Policy'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <div className="privacy-content">

          <section className="privacy-section">
            <h3>1. Introduction</h3>
            <p>
              At Wingman Partners, your privacy is important to us. As a company built on trust, innovation, and 
              transparency, we are committed to safeguarding the personal information you share with us. This 
              Privacy Policy outlines how we collect, use, disclose, and protect your personal data when you engage 
              with our services or visit our website.
            </p>
            <p>
              By accessing our website or providing your information to us, you agree to the terms described in this 
              Privacy Policy.
            </p>
          </section>

          <section className="privacy-section">
            <h3>2. Who We Are</h3>
            <p>
              Wingman Partners, legally registered as WMP Solutions LLP, is a limited liability partnership 
              incorporated in India. We specialize in DevOps services, cloud infrastructure, IT consulting, application 
              development, and automation solutions. Our operations are guided by applicable Indian laws and 
              global data protection regulations including GDPR where applicable.
            </p>
          </section>

          <section className="privacy-section">
            <h3>4. Information We Collect</h3>
            <p>This Privacy Policy applies to all users of our website, existing and prospective clients, service 
              providers, vendors, job applicants, and anyone else whose data we may process as part of our 
              business operations.</p>
            <p>We may collect personal information in the following ways:</p>
            
            <h4>Information You Provide to Us:</h4>
            <p>
              This includes your name, email address, phone number, job title, company name, and any other 
              details you submit through our website forms, emails, calls, job applications, or while availing our 
              services.
            </p>
            
            <h4>Information We Collect Automatically:</h4>
            <p>
              When you visit our website, we may collect data such as your IP address, browser type, device 
              information, location, and browsing behavior. This helps us improve the performance and usability of 
              our site.
            </p>
            
            <h4>Information from Third Parties:</h4>
            <p>
              We may receive information about you from trusted sources such as business directories, LinkedIn, 
              job platforms, event partners, or analytics tools.
            </p>
          </section>

          <section className="privacy-section">
            <h3>5. How We Use Your Information</h3>
            <p>We use your data to:</p>
            <ul>
              <li>Respond to inquiries and demo requests</li>
              <li>Provide and manage services you have contracted with us</li>
              <li>Onboard clients and maintain communication</li>
              <li>Review job applications and conduct hiring processes</li>
              <li>Send updates, newsletters, or marketing communication (only with your consent)</li>
              <li>Improve our website, customer experience, and technical performance</li>
              <li>Detect and prevent security threats or fraud</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h3>6. Legal Basis for Processing</h3>
            <p>
              Depending on the nature of your interaction with us, we may process your information based on your 
              consent, our contractual obligations, legitimate interests, or to comply with legal requirements.
            </p>
          </section>

          <section className="privacy-section">
            <h3>7. Data Retention</h3>
            <p>
              We retain personal data only for as long as necessary. For instance, client-related information is 
              typically retained for up to five years following the end of a project. Data provided by job applicants 
              may be retained for up to two years. You can request earlier deletion unless retention is required by 
              law.
            </p>
          </section>

          <section className="privacy-section">
            <h3>8. Cookies and Tracking Technologies</h3>
            <p>
              Our website uses cookies and similar technologies to offer a personalized experience, analyze website 
              usage, and improve functionality. You may control or disable cookies in your browser settings, though 
              doing so may limit certain features.
            </p>
          </section>

          <section className="privacy-section">
            <h3>9. Data Sharing and Disclosure</h3>
            <p>We do not sell or rent your personal data. However, we may share it with:</p>
            <ul>
              <li>Technology and infrastructure partners who support our services</li>
              <li>Legal or regulatory authorities, when required by law</li>
              <li>Auditors, legal counsel, or other professional advisors</li>
              <li>Partners or affiliates who collaborate with us under strict confidentiality</li>
            </ul>
            <p>All third-party access is governed by appropriate confidentiality or data processing agreements.</p>
          </section>

          <section className="privacy-section">
            <h3>10. International Data Transfers</h3>
            <p>
              Your information may be processed in countries outside of your residence. We take appropriate 
              safeguards to ensure your data remains protected, including contractual obligations with third-party 
              vendors to comply with global data protection standards.
            </p>
          </section>

          <section className="privacy-section">
            <h3>11. Your Rights</h3>
            <p>Depending on applicable laws in your jurisdiction, you may have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request correction or updates to your data</li>
              <li>Request deletion of your personal information</li>
              <li>Object to processing or withdraw consent</li>
              <li>Request a copy of your data in a structured format</li>
            </ul>
            <p>To exercise any of these rights, please contact us at: Connect@wingmanpartners.com</p>
          </section>

          <section className="privacy-section">
            <h3>12. Data Security</h3>
            <p>
              We take data security seriously. Wingman Partners has implemented industry-standard measures 
              including encryption, secure access controls, regular audits, and compliance with internal security 
              protocols. Our systems are regularly updated to protect against unauthorized access and 
              vulnerabilities.
            </p>
          </section>

          <section className="privacy-section">
            <h3>13. External Links</h3>
            <p>
              Our website may contain links to external websites. We are not responsible for the privacy practices of 
              these third-party platforms. We recommend reviewing their privacy policies separately.
            </p>
          </section>

          <section className="privacy-section">
            <h3>14. Updates to This Policy</h3>
            <p>
              This Privacy Policy may be revised from time to time. We encourage you to review it periodically. Any 
              material changes will be communicated on our website, and your continued use of our services will 
              constitute acceptance of the updated terms.
            </p>
          </section>

          <section className="privacy-section">
            <h3>15. Contact Us</h3>
            <p>
              If you have any questions or concerns about this Privacy Policy or how your personal information is 
              handled, please contact us at:
            </p>
            <p>Email: connect@wingmanpartners.com</p>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default PrivacyPolicy;